module.exports = __webpack_public_path__ + "static/media/logo-blue.990b64d2.png";